import React from 'react';
import s from './Input.scss';
import Cleave from 'cleave.js/react';
import createValidator from '../Utils/createValidator';
import { tooltips } from '../../../tooltips';
import Tooltip from 'rc-tooltip';
import Help from '../../../assets/images/icons/help-circle.svg';

class Input extends React.Component {
    state = {
        focus: false,
    }

    toggleFocus = (bool) => {
        this.setState({
            focus: bool,
        });

    }
    handleBlur = () => {
        this.toggleFocus(false)
        this.props.validate();
    }

    render() {
        const { className = '', cleaveOptions, addOn, label, value, validate, placeholder, name, type, tooltip, tooltipDesc, addOnClassName = '', ...rest } = this.props;
        const { focus } = this.state;
        return (
            <div className={s.inputContainer}>
                <div className={s.labelContainer}>
                    {label && <label htmlFor={label} className={`${s.label} ${focus || value || value === 0 ? s.focus : ''}`}>{label}</label>}
                    {(tooltip && (focus || value)) && <Tooltip destroyTooltipOnHide placement="bottom" trigger={['click', 'hover']} overlayStyle={{ maxWidth: '300px', display: 'inline-block'}} overlay={tooltips[tooltipDesc].map(({ description }) => [description])}>
                        <img className={s.helpImg} src={Help} alt="icono de ayuda"></img>
                    </Tooltip>}
                </div>
                {addOn && <span className={`${s.addOn} ${addOnClassName}`}>{addOn}</span>}
                {cleaveOptions ?
                    <Cleave
                        {...rest}
                        options={cleaveOptions}
                        value={value}
                        className={`${s.input} ${className}`}
                        onFocus={() => this.toggleFocus(true)}
                        onBlur={this.handleBlur}
                        placeholder={placeholder}
                        id={label}
                        name={name}
                        type={type}
                    />
                :
                    <input
                        {...rest}
                        onFocus={() => this.toggleFocus(true)}
                        onBlur={this.handleBlur}
                        value={value}
                        className={`${s.input} ${className}`}
                        id={label}
                        placeholder={placeholder}
                        name={name}
                        type={type}
                    />
                }
            </div>
        );
    }
}

export default createValidator(Input);
